// Update selected value display
function updateSelectedValueDisplay() {
  form.querySelectorAll(".product-option").forEach(function (optionDiv) {
    var position = optionDiv.getAttribute("data-option-position");
    var selectedValueSpan = optionDiv.querySelector(".selected-value");
    if (!selectedValueSpan) return;
    // Try swatch first
    var swatchContainer = optionDiv.querySelector(".variant-swatches");
    if (swatchContainer) {
      var selectedSwatch = swatchContainer.querySelector(
        '.variant-swatch.selected[data-option-position="' + position + '"]'
      );
      if (selectedSwatch) {
        selectedValueSpan.textContent =
          selectedSwatch.getAttribute("data-value");
        return;
      }
    }
    // Try dropdown
    var select = optionDiv.querySelector(
      '.variant-select[data-option-position="' + position + '"]'
    );
    if (select) {
      selectedValueSpan.textContent = select.value;
    }
  });
}
// variant-picker-unified.js
// Unified variant picker logic for main product and quick add modal

document.addEventListener("DOMContentLoaded", function () {
  // Helper: format money
  function formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  // Initialize all forms
  document
    .querySelectorAll(".product-form, .add-to-cart-form")
    .forEach(function (form) {
      // Always get product data scoped to this form
      var productJson = form.querySelector("[data-product-json]");
      if (!productJson) return;
      var product;
      try {
        product = JSON.parse(productJson.textContent);
      } catch (e) {
        console.error(
          "Failed to parse product JSON:",
          e,
          productJson.textContent
        );
        return;
      }

      // DOM elements
      var variantSelect = form.querySelector(
        "[data-product-select], .variant-id-select"
      );
      var priceBox = form.querySelector(
        "[data-price-wrapper], .quick-add-modal__price"
      );
      var addToCartBtn = form.querySelector(
        '[data-add-to-cart], button[type="submit"]'
      );
      var addToCartText = form.querySelector("[data-add-to-cart-text]");
      var quantityInput = form.querySelector("[data-quantity-input]");

      // Get selected options
      function getSelectedOptions() {
        var options = [];
        form
          .querySelectorAll(".variant-swatches")
          .forEach(function (container) {
            var selected = container.querySelector(".variant-swatch.selected");
            if (selected) options.push(selected.dataset.value);
          });
        form.querySelectorAll(".variant-select").forEach(function (select) {
          options.push(select.value);
        });
        return options;
      }

      // Find variant by selected options
      function getVariantFromOptions(selectedOptions) {
        return product.variants.find(function (variant) {
          return variant.options.every(function (option, idx) {
            return option == selectedOptions[idx];
          });
        });
      }

      // Update price and ATC button
      function updateUI(variant) {
        // Dispatch a custom event when the variant is updated
        if (variant) {
          var variantChangeEvent = new CustomEvent("variant:change", {
            detail: { variant: variant },
            bubbles: true,
          });
          form.dispatchEvent(variantChangeEvent);
        }
        // Update URL with selected variant (only for main product, not modal)
        if (variant && window.location.pathname.indexOf("/products/") !== -1) {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", variant.id);
          window.history.replaceState({}, "", url.toString());
        }
        if (!variant) {
          if (addToCartBtn) addToCartBtn.disabled = true;
          if (addToCartText) addToCartText.textContent = "Unavailable";
          if (priceBox) priceBox.innerHTML = "";
          return;
        }
        // Always update the correct hidden variant select inside this form
        var hiddenSelect = form.querySelector(
          ".variant-id-select, [data-product-select]"
        );
        if (hiddenSelect) hiddenSelect.value = variant.id;
        // Always update the price only inside the current form/modal
        var priceBox = form.querySelector(
          "[data-price-wrapper], .quick-add-modal__price"
        );
        if (priceBox) {
          var priceHtml = "";
          if (variant.compare_at_price > variant.price) {
            priceHtml =
              '<span class="price price--sale">' +
              formatMoney(variant.price) +
              "</span>" +
              ' <span class="price price--compare">' +
              formatMoney(variant.compare_at_price) +
              "</span>";
          } else {
            priceHtml =
              '<span class="price">' + formatMoney(variant.price) + "</span>";
          }
          priceBox.innerHTML = priceHtml;
        }
        if (addToCartBtn) {
          addToCartBtn.disabled = !variant.available;
        }
        if (addToCartText) {
          addToCartText.textContent = variant.available
            ? "Add to Cart"
            : "Sold Out";
        }
        // Show/hide back-in-stock notification
        let backInStockDiv = form.querySelector(".back-in-stock-container");
        if (backInStockDiv) {
          if (!variant.available) {
            backInStockDiv.style.display = "";
          } else {
            backInStockDiv.style.display = "none";
          }
        }
      }

      // Initial variant
      var selectedOptions = getSelectedOptions();
      var currentVariant =
        getVariantFromOptions(selectedOptions) ||
        product.selected_or_first_available_variant ||
        product.variants[0];
      updateUI(currentVariant);

      // Option change handlers
      form.addEventListener("click", function (e) {
        if (e.target.closest(".variant-swatch")) {
          var swatch = e.target.closest(".variant-swatch");
          var container = swatch.closest(".variant-swatches");
          var optionPosition = swatch.getAttribute("data-option-position");
          container.querySelectorAll(".variant-swatch").forEach(function (s) {
            s.classList.remove("selected");
          });
          swatch.classList.add("selected");
          // Sync select dropdown if present
          var select = form.querySelector(
            '.variant-select[data-option-position="' + optionPosition + '"]'
          );
          if (select) {
            select.value = swatch.getAttribute("data-value");
            var event = new Event("change", { bubbles: true });
            select.dispatchEvent(event);
          }
          // Update only the relevant selected-value span
          var optionDiv = form.querySelector(
            '.product-option[data-option-position="' + optionPosition + '"]'
          );
          if (optionDiv) {
            var selectedValueSpan = optionDiv.querySelector(".selected-value");
            if (selectedValueSpan) {
              selectedValueSpan.textContent = swatch.getAttribute("data-value");
            }
          }
          var selectedOptions = getSelectedOptions();
          var variant = getVariantFromOptions(selectedOptions);
          currentVariant = variant || currentVariant;
          updateUI(currentVariant);
        }
        // Quantity controls
        if (e.target.matches("[data-quantity-minus]")) {
          var input = e.target
            .closest(".quantity-selector")
            .querySelector("[data-quantity-input]");
          var currentValue = parseInt(input.value);
          if (currentValue > 1) input.value = currentValue - 1;
        }
        if (e.target.matches("[data-quantity-plus]")) {
          var input = e.target
            .closest(".quantity-selector")
            .querySelector("[data-quantity-input]");
          var currentValue = parseInt(input.value);
          input.value = currentValue + 1;
        }
      });
      form.addEventListener("change", function (e) {
        if (e.target.classList.contains("variant-select")) {
          var select = e.target;
          var optionPosition = select.getAttribute("data-option-position");
          // Sync swatch selection if present
          var swatchContainer = form.querySelector(
            ".variant-swatches[data-option-name]"
          );
          if (swatchContainer) {
            swatchContainer
              .querySelectorAll(".variant-swatch")
              .forEach(function (swatch) {
                if (
                  swatch.getAttribute("data-option-position") === optionPosition
                ) {
                  if (swatch.getAttribute("data-value") === select.value) {
                    swatch.classList.add("selected");
                  } else {
                    swatch.classList.remove("selected");
                  }
                }
              });
          }
          // Update only the relevant selected-value span
          var optionDiv = form.querySelector(
            '.product-option[data-option-position="' + optionPosition + '"]'
          );
          if (optionDiv) {
            var selectedValueSpan = optionDiv.querySelector(".selected-value");
            if (selectedValueSpan) {
              selectedValueSpan.textContent = select.value;
            }
          }
          var selectedOptions = getSelectedOptions();
          var variant = getVariantFromOptions(selectedOptions);
          currentVariant = variant || currentVariant;
          updateUI(currentVariant);
        }
      });

      // Add to cart handler
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (!currentVariant || !currentVariant.available) return;
        var formData = new FormData();
        formData.append("id", currentVariant.id);
        formData.append("quantity", quantityInput ? quantityInput.value : 1);
        fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (addToCartText) {
              var originalText = addToCartText.textContent;
              addToCartText.textContent = "Added!";
              setTimeout(function () {
                addToCartText.textContent = originalText;
              }, 2000);
            }
          })
          .catch(function (error) {
            console.error("Error adding to cart:", error);
          });
      });
    });
});
